import type { ContentBlockItem } from '@/components/contentBlocks';
import { stripHtmlToText } from '@/utils/html';
import { getReadingTime, getWordCount } from '@/utils/contentMetrics';

function appendValueText(parts: string[], value: unknown): void {
  if (value === null || value === undefined) return;
  if (typeof value === 'boolean') return;
  if (typeof value === 'number') return;
  if (typeof value === 'string') {
    const s = value.trim();
    if (!s) return;
    const plain = s.includes('<') ? stripHtmlToText(s) : s;
    const normalized = plain.replace(/\s+/g, ' ').trim();
    if (normalized) parts.push(normalized);
    return;
  }
  if (Array.isArray(value)) {
    for (const item of value) appendValueText(parts, item);
    return;
  }
  if (typeof value === 'object') {
    for (const [key, v] of Object.entries(value as Record<string, unknown>)) {
      if (key === 'page' && typeof v === 'number') continue;
      appendValueText(parts, v);
    }
  }
}

/**
 * Concatenates readable plain text from a page StreamField `content` array (API shape).
 */
export function collectPlainTextFromPageContent(
  blocks: ContentBlockItem[] | undefined | null
): string {
  if (!blocks?.length) return '';
  const parts: string[] = [];
  for (const block of blocks) {
    appendValueText(parts, block.value);
  }
  return parts.join(' ').replace(/\s+/g, ' ').trim();
}

export function getReadingTimeForPageContent(
  lang: string,
  content: ContentBlockItem[] | undefined | null
): number {
  const text = collectPlainTextFromPageContent(content);
  return getReadingTime(lang, getWordCount(lang, text));
}
